import React from "react";
import _ from "lodash";
import { toast } from "react-toastify";
import { tripModeOptions } from ".";
import * as Yup from "yup";

export function createInitialValues({ search_form, tripMode, t }) {
  const output = {
    origin: {
      origin_code: _.get(search_form.origin, "origin_code", []),
      origin_meta: _.get(
        search_form.origin,
        "origin_meta",
        tripMode === "poi_to_air" ? {} : []
      ),
    },
    destination: {
      destination_code: _.get(search_form.destination, "destination_code", []),
      destination_meta: _.get(
        search_form.destination,
        "destination_meta",
        tripMode === "poi_to_air" ? [] : {}
      ),
    },
    inboundPickupDate: [search_form.inboundPickupDate],
    tripMode: tripModeOptions(t).find((t) => t.value === search_form.tripMode),
  };
  return output;
}

export async function validateTransferSearch(values, showToast = true) {
  var errors = [];
  const schema = Yup.object().shape({
    origin: Yup.object().shape({
      name: Yup.string().required("Origin is required"),
      location_type: Yup.string().required("Origin is required"),
    }),
    destination: Yup.object().shape({
      name: Yup.string().required("Destination is required"),
      location_type: Yup.string().required("Destination is required"),
    }),
    inboundPickupDate: Yup.date().required("Inbound Pickup Date is required"),
    tripMode: Yup.string().required("Trip Mode is required"),
  });

  await schema.validate(values, { abortEarly: false }).catch((err) => {
    errors = [...new Set(err.errors)];
    if (showToast) {
      toast.warning(
        <ul>
          {errors.map((msg, idx) => (
            <li key={idx}>{msg}</li>
          ))}
        </ul>
      );
    }
  });
  return errors.length > 0;
}
